(function ($, undefined) {
    'use strict';
    var utils;
    var locationsUtils;
      const domain = window.location.hostname;
        let url = "";

        if (domain === "localhost") {
            url = `http://localhost:9006`;
        } else {
            url = `/pdf-forms-service`;
        }

    var init = function () {
        utils = Fw.component.models().utils;
        locationsUtils = Fw.component.models().locationsUtils;
        if (window.location.pathname.includes("custom-forms")) {
            const deleteButtons = document.querySelectorAll(".confirm-delete");

            deleteButtons.forEach(button => {
                button.classList.remove("confirm-delete");
                button.classList.add("confirm-delete-pdf");
            });
            getForms();
            $('.submit-custom-form-document').on('click', onSaveDocument);
            $(document).on('click', '.delete-popup-btn', function () {
                const itemId = $(this).data('item-id');

                // Use closest modal to scope properly if there are multiple
                const confirmBtn = $('.confirm-delete-pdf');

                if (confirmBtn.length) {
                    confirmBtn.removeAttr('data-item-id').attr('data-item-id', itemId);
                    console.log('File ID set on confirm-delete-pdf:', itemId);
                } else {
                    console.warn('confirm-delete-pdf button not found!');
                }
            });
        }
    };

    function getForms() {
        const urlParams = new URLSearchParams(window.location.search);
        const gid = urlParams.get('gid');
        let userId = document.getElementById("userId");

        if (userId != null && userId.value != null) {
            userId = userId.value;
            if (!userId) {
                console.error("User ID not found.");
                return;
            }

            $.ajax({
                url: url + `/public/get-forms?personId=${userId}`,
                type: "GET",
                data: {
                    locationId: gid
                },
                success: function (response) {

                    let output = `<tr class="table__tr template">
                    <td class="table__td " data-label="Attached button"></td>
                    <td class="table__td " data-label="File name">Actif</td>
                    <td class="table__td " data-label=" ">
                        <div class="table__actions-container"><button type="button"
                                class="table__btn table__btn_delete stool-shared-popup-btn delete-popup-btn"
                                data-no-reload="true" data-id="delete-location-document-popup" data-item-id=""
                                data-type="location-document"><span class="table__icon"><svg
                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.3 25.6" width="22.3"
                                        height="25.6">
                                        <path
                                            d="M22.1,2.6c-0.2-0.2-0.4-0.3-0.6-0.3h-6.5V1.4c0-0.8-0.6-1.4-1.4-1.4H8.8C8,0,7.4,0.6,7.4,1.4v0.9H0.9     c-0.2,0-0.4,0.1-0.6,0.2C0.1,2.7,0,3,0,3.2C0,3.6,0.3,4,0.9,4.1h0.9l0.7,19.2c0,1.3,1.1,2.4,2.4,2.4c0,0,0,0,0,0h12.5c0,0,0,0,0,0     c1.3,0,2.4-1,2.4-2.4l0.7-19.2h0.8c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.3-0.4,0.3-0.6S22.2,2.8,22.1,2.6z M9.1,2.4V1.7h4.2v0.7H9.1z     M4.9,24c-0.4,0-0.8-0.3-0.8-0.7L3.4,4.1h15.5l-0.7,19.2v0c0,0.4-0.4,0.7-0.8,0.7c0,0,0,0,0,0H4.9C4.9,24,4.9,24,4.9,24z">
                                        </path>
                                        <path
                                            d="M7,8.6L7,8.6c-0.3,0-0.6,0.3-0.6,0.6l0.2,9.7c0,0.3,0.3,0.6,0.6,0.6h0c0.3,0,0.6-0.3,0.6-0.6L7.5,9.2     C7.5,8.8,7.3,8.6,7,8.6z">
                                        </path>
                                        <path
                                            d="M11.2,8.6c-0.3,0-0.6,0.3-0.6,0.6v9.7c0,0.3,0.2,0.6,0.6,0.6s0.6-0.2,0.6-0.6c0,0,0,0,0,0V9.2     C11.7,8.9,11.5,8.6,11.2,8.6z">
                                        </path>
                                        <path
                                            d="M15.4,8.6c-0.3,0-0.6,0.3-0.6,0.6l-0.2,9.7c0,0.3,0.3,0.6,0.6,0.6h0c0.3,0,0.6-0.3,0.6-0.6l0.2-9.7     C15.9,8.9,15.7,8.6,15.4,8.6z">
                                        </path>
                                    </svg></span></button></div>
                    </td>
                </tr>`;
                    if (Array.isArray(response)) {
                        for(let i = 0; i < response.length; i++) {

                            
                            
                            output += `<tr class="table__tr " data-id="location-document-row-${response[i].secureFileId}" data-value="${response[i].secureFileId}">
                    <td class="table__td" data-label="name" data-value="${response[i].fileName}">
                        <a href="${url}/public/form?id=${response[i].secureFileId}&personId=${userId}" target="_blank">
                            ${response[i].fileName}
                        </a>
                    </td>
                    <td class="table__td " data-label=" ">
                        <div class="table__actions-container"><button type="button"
                                class="table__btn table__btn_delete stool-shared-popup-btn delete-popup-btn"
                                data-id="delete-location-document-popup" data-item-id="${response[i].secureFileId}" data-no-reload="true"
                                data-type="location-document"><span class="table__icon"><svg
                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.3 25.6" width="22.3"
                                        height="25.6">
                                        <path
                                            d="M22.1,2.6c-0.2-0.2-0.4-0.3-0.6-0.3h-6.5V1.4c0-0.8-0.6-1.4-1.4-1.4H8.8C8,0,7.4,0.6,7.4,1.4v0.9H0.9     c-0.2,0-0.4,0.1-0.6,0.2C0.1,2.7,0,3,0,3.2C0,3.6,0.3,4,0.9,4.1h0.9l0.7,19.2c0,1.3,1.1,2.4,2.4,2.4c0,0,0,0,0,0h12.5c0,0,0,0,0,0     c1.3,0,2.4-1,2.4-2.4l0.7-19.2h0.8c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.3-0.4,0.3-0.6S22.2,2.8,22.1,2.6z M9.1,2.4V1.7h4.2v0.7H9.1z     M4.9,24c-0.4,0-0.8-0.3-0.8-0.7L3.4,4.1h15.5l-0.7,19.2v0c0,0.4-0.4,0.7-0.8,0.7c0,0,0,0,0,0H4.9C4.9,24,4.9,24,4.9,24z">
                                        </path>
                                        <path
                                            d="M7,8.6L7,8.6c-0.3,0-0.6,0.3-0.6,0.6l0.2,9.7c0,0.3,0.3,0.6,0.6,0.6h0c0.3,0,0.6-0.3,0.6-0.6L7.5,9.2     C7.5,8.8,7.3,8.6,7,8.6z">
                                        </path>
                                        <path
                                            d="M11.2,8.6c-0.3,0-0.6,0.3-0.6,0.6v9.7c0,0.3,0.2,0.6,0.6,0.6s0.6-0.2,0.6-0.6c0,0,0,0,0,0V9.2     C11.7,8.9,11.5,8.6,11.2,8.6z">
                                        </path>
                                        <path
                                            d="M15.4,8.6c-0.3,0-0.6,0.3-0.6,0.6l-0.2,9.7c0,0.3,0.3,0.6,0.6,0.6h0c0.3,0,0.6-0.3,0.6-0.6l0.2-9.7     C15.9,8.9,15.7,8.6,15.4,8.6z">
                                        </path>
                                    </svg></span></button></div>
                    </td>
                </tr>`;
                            
                        }

                        document.querySelector('#pdf-form-data').innerHTML = output;
                    }
                },
                error: function (xhr, status, error) {
                    console.error("Error fetching forms:", xhr, status, error);
                }
            })

        }

    }

    function onSaveDocument() {
        let userId = document.getElementById("userId");
        if (userId != null && userId.value != null) {
            var form = $('.add-location-document-form');
            var fileInput = $('input[type=file]', form);
            var input = $('input[type="text"]', form);
            form.removeClass('has-error');
            fileInput.removeClass('error');
            input.removeClass('error');
            var title = input.val();

            if (fileInput[0].files.length === 0) {
                fileInput.addClass('error');
                form.addClass('has-error');
            }
            if (input.val().length === 0) {
                input.addClass('error');
                form.addClass('has-error');
            }

            locationsUtils.addOverlay();
            if (!form.hasClass('has-error')) {
                saveHtmlForm(fileInput[0].files, (response) => {
                    getForms();
                    resetForm();
                    locationsUtils.removeOverlay();
                }, form.attr('data-location-id'), userId.value, title);
            }
        }
	}

    function saveHtmlForm(files, callback, locationId, userId, name){
        if (files !== undefined && files.length > 0) {
			var data = new FormData();
			data.append('file', files[0]);

			// Always append the ajax flag
			data.append('ajax', 'true');

			data.append('locationId', locationId);
			data.append('name', name);
			data.append('personId', userId);

			$.ajax({
				url: url+'/public/pdf-to-html/convert',
				cache: false,
				contentType: false,
				processData: false,
				method: 'POST',
				data: data,
				complete: function (response) {
					callback(response.responseText);
				}
			});
		} else {
			callback();
		}
    }

    $(document).on('click', '.confirm-delete-pdf', function () {
        const fileId = $(this).attr('data-item-id');
        if (fileId) {
            if($('#delete-popup-input').val().toLowerCase() === 'yes')
                deleteFile(fileId);
            else alert("invalid input, please type 'yes' to confirm deletion.");
        } else {
            alert("File ID is missing.");
        }
    });

    function deleteFile(fileId) {
        const userIdElement = document.getElementById("userId");
        if (!userIdElement) {
            alert("User ID not found.");
            return;
        }

        const userId = userIdElement.value;

        if (!fileId || !userId) {
            alert("Missing user or file ID.");
            return;
        }

        locationsUtils.addOverlay();

        $.ajax({
            url: `${url}/public/delete-form?id=${fileId}&personId=${userId}`, // Adjust this URL to your actual Spring controller mapping
            type: "DELETE",
            complete: function (response) {
                getForms();
                $('.stool-shared-popup').removeClass('visible');
                $('#delete-popup-input').val('');
                locationsUtils.removeOverlay();
            }
        });
    }

    function resetForm(){
        const input = document.querySelector('#add-document-location-name-input');
        const $context = $('#adminUploadFile1').closest('.upload-input');
        const $input = $context.find('input');
        $input.val('');
        $input.trigger('change');
        $context.removeClass('upload-input_completed');

        // Optional: reset placeholder
        $context.find('.upload-input__placeholder').text('Choose a file');
        input.value = '';
    }

    $(window).ready(function () {
        init();
    });
})(jQuery);
